import { StatementDataStateContext } from "@bToC/Store/Data/Statements/StatementSelector";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import LocalizedDateTime from "@insite/content-library/Components/LocalizedDateTime";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import * as React from "react";
import { useContext } from "react";
import { css } from "styled-components";

export interface StatementDetailsHeaderStyles {
    container?: GridContainerProps;
    titleItem?: GridItemProps;
    title?: TypographyProps;
    titleText?: TypographyProps;
    titleWrapper?: GridContainerProps;
}

export const statementHeaderStyles: StatementDetailsHeaderStyles = {
    titleItem: {
        width: 12,
        css: css`
            padding-bottom: 10px;
        `,
    },
    title: {
        weight: "bold",
        size: "18px",
        as: "h2",
        css: css`
            @media print {
                font-size: 15px;
            }
            width: 100%;
            padding: 15px 0;
            border-bottom: 1px solid ${getColor("common.border")};
        `,
    },
    titleText: {
        variant: "h3",
        css: css`
            @media print {
                font-size: 12px;
            }
            margin-bottom: 5px;
            font-size: 16px;
        `,
    },
    titleWrapper: {
        css: css`
            margin: 20px 0;
        `,
    },
};

const styles = statementHeaderStyles;

const StatementDetailsHeader = () => {
    const statementsDataView = useContext(StatementDataStateContext);

    const statement = statementsDataView.value;

    if (!statement) {
        return null;
    }

    return (
        <GridContainer {...styles.container} data-test-selector="statementDetail_header">
            <GridItem {...styles.titleItem}>
                <GridContainer {...styles.titleWrapper}>
                    <GridItem width={4}>
                        <StyledWrapper>
                            <Typography as="p" {...styles.titleText}>{translate("Statement Number")}</Typography>
                            <Typography as="p">{statement.statementNumber}</Typography>
                        </StyledWrapper>
                    </GridItem>
                    <GridItem width={4}>
                        <StyledWrapper>
                            <Typography as="p" {...styles.titleText}>{translate("Account Number")}</Typography>
                            <Typography as="p">{statement.billTo}</Typography>
                        </StyledWrapper>
                    </GridItem>
                    <GridItem width={4}>
                        <StyledWrapper>
                            <Typography as="p" {...styles.titleText}>{translate("Date")}</Typography>
                            <LocalizedDateTime
                                dateTime={statement.statementDate}
                                options={{ year: "numeric", month: "numeric", day: "numeric" }}
                            />
                        </StyledWrapper>
                    </GridItem>
                </GridContainer>
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: StatementDetailsHeader,
    definition: {
        group: "Basic",
        displayName: "Statement Details Header",
    },
};

export default widgetModule;
